import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import PostCard from "../page/post/commonComponent/PostCard/PostCard";
import {
  handleDeletePost,
  handleGetMyFeedPosts,
} from "../appStore/actions/ArkchatGroup/action";
import { serviceTypeName, serviceTypeValue } from "../utils/constant";
import { getServiceCategory } from "../appStore/actions/masterData/masterDataAction";
import {
  handleSavePreviewEditPostData,
  handleSetserviceTypePost,
} from "../appStore/actions/AppState/action";
import managePostEmpty from "../assets/images/post/managePostEmpty.svg";
import LoadingSpinner from "./LoadingSpinner/LoadingSpinner";

const MyFeedPostsTab = ({ feed, isSideBarOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const myFeedPostList = useSelector(
    (state) => state?.arkchatgroup?.myFeedPostList
  );
  const userData = useSelector((state) => state?.profile?.profileData?.data);
  const subscriberId = userData?.activeSubscriber?.id;

  useEffect(() => {
    if (subscriberId) {
      setIsLoading(true);
      dispatch(handleGetMyFeedPosts(subscriberId, feed)).then(() => {
        setIsLoading(false);
      });
    }
  }, [dispatch, subscriberId, feed]);

  const handleEditClick = (data) => {
    dispatch(handleSetserviceTypePost(data?.type));
    dispatch(getServiceCategory(data?.type));
    const createPostData = {
      category: data?.category,
      core_team: {},
      subscriber_id: data?.subscriber_id,
      tags: data?.tags || [],
      topic_id: 0,
      type: data?.type,
      countries: data?.countries || [],
      post_data: data?.postData,
      tagsInput: "",
    };
    const countriesArray = data?.countries?.map((name) => ({ name }));
    const localPreviewData = {
      selectedCategory: data?.category,
      createPostData,
      selectedCountries: countriesArray,
      selectedImageList: data?.attachments,
      selectedVideoList: data?.attachments,
      post_id: data?.post_id,
      authorized_seller: data?.authorizedSeller,
      editBrandData: data?.brandInfo,
      editArtistData: data?.artistInfo,
    };
    dispatch(handleSavePreviewEditPostData(localPreviewData));
    localStorage.setItem("post_id", JSON.stringify(data?.id));
    let tabValue;
    if (
      data?.type === serviceTypeName?.Service ||
      data?.type === serviceTypeName?.Art ||
      data?.type === serviceTypeName?.Product
    ) {
      tabValue = 0;
    } else if (data?.type === serviceTypeName?.Photo) {
      tabValue = 1;
    } else if (data?.type === serviceTypeName?.Videos) {
      tabValue = 2;
    }
    localStorage?.setItem("tabValue", tabValue);
    navigate("/post/post-create");
  };

  const handleDeleteClick = (post_id) => {
    dispatch(handleDeletePost(post_id)).then((res) => {
      if (res?.status && subscriberId) {
        dispatch(handleGetMyFeedPosts(subscriberId, feed));
      }
    });
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!myFeedPostList?.data?.posts?.length) {
    return (
      <Box mt={"2.5rem"}>
        <Box textAlign={"center"}>
          <img src={managePostEmpty} alt="No posts" />
        </Box>
        <Box textAlign={"center"}>
          <Typography>There is nothing here yet.</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box mt={"1rem"}>
      <ResponsiveMasonry
        columnsCountBreakPoints={{
          1194: !isSideBarOpen ? 3 : 2,
          1195: !isSideBarOpen ? 4 : 3,
        }}
      >
        <Masonry gutter="1rem">
          {myFeedPostList?.data?.posts?.map((data, i) => (
            <Box width={"100%"} key={i + "myFeedPost"}>
              <PostCard
                type={serviceTypeValue[data?.type]}
                postPreviewData={data}
                handleEditClick={handleEditClick}
                handleDeleteClick={handleDeleteClick}
                showBtn={true}
              />
            </Box>
          ))}
        </Masonry>
      </ResponsiveMasonry>
    </Box>
  );
};

export default MyFeedPostsTab;
